module.exports = __webpack_public_path__ + "static/img/cabecera.470ce4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/contactenos/cabecera.jpg
// module id = L27D
// module chunks = 0